module.exports = __webpack_public_path__ + "img/mobile-22.b0a8ec29.png";